import axiosInstance from './interceptor';

export const signup = async (
  first_name:string,
  last_name:string,
  email: string,
  password: string,
  roles: [string],
  userinfo: any,
  organization: boolean = false
): Promise<any> => {
  try {
    const response = await axiosInstance.post(`/auth/signup/`, {
      first_name,
      last_name,
      username: `${first_name} ${last_name}`,
      email,
      password,
      roles,
      organization,
      ...userinfo
    });
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
};

export const login = async (email: string, password: string): Promise<any> => {
  try {
    const response = await axiosInstance.post(`/auth/signin/`, {
      email,
      password,
    },
      {
        headers: {
          "Accept": "*/*",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
};

export const verifyEmail = async (token = ''): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/auth/verify-email/${token}`);
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
};

export const sendPasswordReset = async (email: string): Promise<any> => {
  try {
    const response = await axiosInstance.post(`/auth/forgot-password`, { email });
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
};

export const resetPassword = async (token: string, newPassword: string): Promise<void> => {
  try {
    const response = await axiosInstance.post(`/auth/reset-password`, {
      token,
      newPassword,
    });

    if (response.status !== 200) throw new Error("Something went wrong");
  } catch (error: any) {
    const message =
      error.response?.data?.message || error.message || "Reset failed.";
    throw new Error(message);
  }
};

export const get_csrf_token = async (): Promise<any> => {
  try {
    const response = await axiosInstance.get(`/api/hello/`);
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
};

export const callbackOauthGoogleLogin = async (accessToken: string) => {
  try {
    const response = await axiosInstance.get(`/auth/google/?access_token=${accessToken}`);
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
}
export const callbackOauthGoogleRegister = async (access_token: string, is_coach: string = '', data: any = {}) => {
  try {
    const response = await axiosInstance.post(`/auth/google/`, {
      access_token,
      is_coach,
      ...data
    },
      {
        headers: {
          "Accept": "*/*",
        },
      }
    );
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
}

export const callbackOauthLogin = async (platform: string, accessToken: string) => {
  try {
    const response = await axiosInstance.get(`/auth/${platform}/?access_token=${accessToken}`);
    return response.data;
  } catch (error: any) {
    throw error.response ? error.response.data : error.message;
  }
}

